/* ==========================================================================
   Bundle PDP closing CTA — pointing the button at the shade picker.

   The button is a real link to whatever the setting says, so it works with
   JavaScript off and on a page that has no picker at all. Only when a picker
   is actually present does this take over: if the shopper has already made
   every choice it needs, it takes them straight to add-to-cart, and if they
   have not, it takes them to the first shade swatch.

   This is the same behaviour assets/bundle-finished-look.js gives its own
   CTA. The two are deliberately separate files rather than one shared one:
   each section loads only its own script, and the finished-look file carries
   a slider and a drag handler this section has no use for.
   ========================================================================== */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollTo(node) {
    if (!node) return;
    node.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'center'
    });
  }

  /* The picker used to live inside the hero, so the first `[data-bundle-hero]`
     root was always the right target. It now has its own section, and the hero
     no longer contains it — so pick the root that actually holds a shade
     picker, and only fall back to the first one if none does. */
  function findPicker() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-hero]'));
    return roots.filter(function (root) {
      return root.querySelector('[data-bh-shade]');
    })[0] || roots[0] || null;
  }

  function setup(section) {
    var cta = section.querySelector('[data-fc-cta]');
    if (!cta) return;

    cta.addEventListener('click', function (event) {
      // Anything that asks for a new tab or window is left to the browser,
      // since the link is real.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var picker = findPicker();

      // No picker on this page: leave the link alone and let it navigate to
      // whatever the setting points at.
      if (!picker) return;

      var submit = picker.querySelector('[data-bh-submit]');
      var ready = !!submit && submit.getAttribute('aria-disabled') === 'false';

      event.preventDefault();

      if (ready) {
        // Every choice is already made — go straight to add-to-cart. Focus
        // moves too, so a keyboard shopper carries on from the same place.
        scrollTo(submit);
        if (submit.focus) {
          window.setTimeout(function () {
            submit.focus({ preventScroll: true });
          }, prefersReducedMotion() ? 0 : 500);
        }
        return;
      }

      // Something is still unchosen. Where the picker is still collapsed
      // inside a hero, its reveal button expands it and scrolls to the first
      // swatch — defer to that rather than duplicating the behaviour. With
      // the picker in its own section there is no reveal button, and the
      // scroll below is the whole job.
      var reveal = picker.querySelector('[data-bh-reveal]');
      if (reveal) {
        reveal.click();
        return;
      }

      scrollTo(picker.querySelector('[data-bh-swatch]') || picker.querySelector('[data-bh-shade]') || picker);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle-final-cta]').forEach(function (section) {
      if (section.dataset.fcReady === 'true') return;
      section.dataset.fcReady = 'true';
      setup(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
